import React, { useContext } from "react";
import styles from "./Images3.module.scss";
import { Context } from "../../Store";
import { motion } from "framer-motion";

const Images3 = (props) => {
  let { dir, variants1 } = useContext(Context);
  const { experiencesRes, start } = props;
  const { subTitle, desc, images } = experiencesRes[start];

  return (
    <>
      <motion.section
        variants={variants1}
        initial="hidden"
        animate="showComponets"
        id={styles.subscribeAndRegister}
      >
        <div className={styles.container}>
          <div className={styles.item0}>
            <h3>{subTitle}</h3>
            <p>{desc}</p>
          </div>
          <div className={styles.item1}>
            <img
              className={dir === "ltr" ? styles.sub0l : styles.sub0r}
              src={images[0]?.image}
              alt=""
            />

            <img
              className={dir === "ltr" ? styles.sub1l : styles.sub1r}
              src={images[1]?.image}
              alt=""
            />
            <img
              className={dir === "ltr" ? styles.sub2l : styles.sub2r}
              src={images[2]?.image}
              alt=""
            />
          </div>
        </div>
      </motion.section>
    </>
  );
};

export default Images3;
